import Reflux from 'reflux';
import AlertActions from '../AlertActions';
import RetIvaStore from './RetIvaStore';
import RetIslrStore from './RetIslrStore';
import ProveedorStore from './ProveedorStore';
import AuthStore from './AuthStore';
import ErrorHandlerStore from './ErrorHandlerStore';

var AlertsStore = Reflux.createStore({
    init: function() {
        this.listenToMany(AlertActions);
        this.listenTo(RetIvaStore, this.stopLoading);
        this.listenTo(ProveedorStore, this.stopLoading);
        this.listenTo(RetIslrStore, this.stopLoading);
        this.listenTo(ErrorHandlerStore, this.stopLoading);
        this.listenTo(AuthStore, this.auth);
    },

    /**
     * Triggers a store change to show there are new messages
     * 
     * @param {string} e The type of alert that is being sent.
     * @param {string} title The title for the modal
     * @param {any} messages the messages to be displayed as children of modal
     * 
     * @return {void}
     */
    alert: function(e, title, messages) {
        this.trigger(e, title, messages);
        this.stopLoading('stop');
    },

    /**
     * Triggers a store change to show that a new resource was successfully
     * created.
     * 
     * @param {string} resource The name of the created resource
     * @param {string} id An identifier of the created resource
     * 
     * @return {void}
     */
    createdResource: function(resource, id) {
        let title = resource + ' creado con exito',
            message = 'Usted ha creado un/a'+resource+' correctamente bajo el número: '+id;

        this.trigger('open', title, message);
    },

    /**
     * Triggers a store change to show that an existing resource was successfully
     * updated.
     * 
     * @param {string} resource The name of the updated resource
     * @param {string} id An identifier of the updated resource
     * 
     * @return {void}
     */
    updatedResource: function(resource, id) {
        let title = resource + ' editado con exito',
            message = 'Usted editado un/a '+resource+' bajo el id: ' + id + ' de forma exitosa';

        this.trigger('open', title, message);
    },

    startLoading: function(state) {
        
        this.trigger('startLoading', state);
    },
    stopLoading: function(e) {
        if (e === 'auth_failed')
            this.trigger('auth_failed');
 
        this.trigger('stopLoading');
    },

    auth: function(e) {
        if (e === 'auth_success') {
            this.trigger('login');
            this.stopLoading();
        } else {
            this.stopLoading();
        }
            
    },

    resize: function(dims) {
        this.trigger('resize', dims);
    },

    configureAppBar: function(title, leftIcon, rightIcon) {
        this.trigger('configureAppBar', title, leftIcon, rightIcon);
    }

});

export default AlertsStore;


/** WEBPACK FOOTER **
 ** ./app-react/reflux/stores/AlertsStore.js
 **/